// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__tRbEW","info":"PatientInfo_info__2PdVC"};